import {
  GET_PROFILE,
  GET_PROFILE_FAIL,
  GET_PROFILE_SUCCESS,
  REMOVE_USER_INFO,
  RESET_UPLOAD_AVATAR,
  UPDATE_PROFILE,
  UPDATE_PROFILE_FAIL,
  UPDATE_PROFILE_SUCCESS,
  UPLOAD_AVATAR,
  UPLOAD_AVATAR_FAIL,
  UPLOAD_AVATAR_SUCCESS,
} from "./actionTypes";

// GET_PROFILE
export const getProfile = () => {
  return {
    type: GET_PROFILE,
  };
};

export const getProfileSuccess = (userInfo, avatar_id, avatarImg) => {
  return {
    type: GET_PROFILE_SUCCESS,
    userInfo,
    avatar_id,
    avatarImg,
  };
};

export const getProfileFail = error => {
  return {
    type: GET_PROFILE_FAIL,
    error,
  };
};

export const removeUserInfo = () => {
  return {
    type: REMOVE_USER_INFO,
  };
};

// UPLOAD_AVATAR
export const uploadAvatar = data => {
  return {
    type: UPLOAD_AVATAR,
    data,
  };
};

export const uploadAvatarSuccess = avatar_id_upload => {
  return {
    type: UPLOAD_AVATAR_SUCCESS,
    avatar_id_upload,
  };
};

export const uploadAvatarFail = error => {
  return {
    type: UPLOAD_AVATAR_FAIL,
    error,
  };
};

export const resetUploadAvatar = () => {
  return {
    type: RESET_UPLOAD_AVATAR,
  };
};

// UPDATE_PROFILE
export const updateProfile = (display_name, avatar_id) => {
  return {
    type: UPDATE_PROFILE,
    display_name,
    avatar_id,
  };
};

export const updateProfileSuccess = (userInfo, avatar_id, avatarImg) => {
  return {
    type: UPDATE_PROFILE_SUCCESS,
    userInfo,
    avatar_id,
    avatarImg,
  };
};

export const updateProfileFail = error => {
  return {
    type: UPDATE_PROFILE_FAIL,
    error,
  };
};
